var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('KSimpleLeafletMap',_vm._b({ref:"k_simple_leafletmap",on:{"click":function($event){return _vm.$emit('click', $event)}}},'KSimpleLeafletMap',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }